/* Jellybelly theme */
(function(){
  'use strict';
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function(e){
    var t=e.target.closest('[data-menu-toggle]');
    if(!t) return;
    var nav=$('#mnav'); if(!nav) return;
    var open=nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open?'true':'false');
  });

  /* ---------- cart drawer ---------- */
  var drawer=$('#cart-drawer'), scrim=$('#cart-scrim');
  function openCart(){ if(!drawer)return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    scrim.classList.add('is-open'); document.body.style.overflow='hidden';
    var c=drawer.querySelector('[data-drawer-close]'); if(c) c.focus(); }
  function closeCart(){ if(!drawer)return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    scrim.classList.remove('is-open'); document.body.style.overflow=''; }
  window.JB={openCart:openCart,closeCart:closeCart};

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){ e.preventDefault(); openCart(); }
    if(e.target.closest('[data-drawer-close]')||e.target.closest('#cart-scrim')) closeCart();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });

  function refreshDrawer(){
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root+'?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function(r){return r.text()})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.querySelector('#cart-drawer-inner');
        var cur=$('#cart-drawer-inner');
        if(fresh&&cur) cur.innerHTML=fresh.innerHTML;
        var n=doc.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function(el){
          if(!n) return;
          el.textContent=n.textContent;
          el.hidden = (n.textContent.trim()==='0'||n.textContent.trim()==='');
        });
      });
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function(e){
    var form=e.target.closest('form[data-cart-add]');
    if(!form) return;
    e.preventDefault();
    var btn=form.querySelector('[type=submit]');
    if(btn){ btn.disabled=true; btn.dataset.label=btn.textContent; btn.textContent='Adding…'; }
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return refreshDrawer(); })
      .then(function(){ openCart(); })
      .catch(function(){ form.submit(); })
      .finally(function(){ if(btn){ btn.disabled=false; btn.textContent=btn.dataset.label||'Add to cart'; } });
  });

  /* ---------- cart line changes ---------- */
  document.addEventListener('click', function(e){
    var el=e.target.closest('[data-line-change]');
    if(!el) return;
    e.preventDefault();
    var line=el.getAttribute('data-line');
    var qty=el.getAttribute('data-qty');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:Number(line),quantity:Number(qty)})})
      .then(function(){ 
        if(document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshDrawer();
      });
  });

  /* ---------- product variant switching ---------- */
  $$('[data-variant-picker]').forEach(function(root){
    var data=JSON.parse(root.querySelector('[data-variants]').textContent);
    var idInput=root.querySelector('[name="id"]');
    var priceEl=root.querySelector('[data-price]');
    var btn=root.querySelector('[data-add-btn]');
    var skuEl=root.querySelector('[data-sku]');

    function selected(){
      return $$('[data-opt]',root).filter(function(b){return b.getAttribute('aria-pressed')==='true'})
        .map(function(b){return b.getAttribute('data-value')});
    }
    function update(){
      var sel=selected();
      var match=data.find(function(v){ return v.options.every(function(o,i){ return o===sel[i]; }); });
      if(!match) return;
      idInput.value=match.id;
      if(priceEl) priceEl.innerHTML=match.price_html;
      if(skuEl) skuEl.textContent=match.sku||'';
      if(btn){
        btn.disabled=!match.available;
        btn.textContent=match.available?(btn.dataset.add||'Add to cart'):(btn.dataset.soldout||'Sold out');
      }
      if(match.featured_image){
        var main=root.closest('.pdp')?root.closest('.pdp').querySelector('[data-main-image]'):null;
        if(main) main.src=match.featured_image;
      }
      if(history.replaceState){
        var u=new URL(window.location.href); u.searchParams.set('variant',match.id);
        history.replaceState({},'',u.toString());
      }
    }
    root.addEventListener('click', function(e){
      var b=e.target.closest('[data-opt]');
      if(!b||b.disabled) return;
      $$('[data-opt][data-index="'+b.getAttribute('data-index')+'"]',root)
        .forEach(function(o){ o.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
      update();
    });
  });

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function(g){
    g.addEventListener('click', function(e){
      var t=e.target.closest('[data-thumb]'); if(!t) return;
      var main=g.querySelector('[data-main-image]');
      if(main){ main.src=t.getAttribute('data-full'); main.srcset=''; }
      $$('[data-thumb]',g).forEach(function(x){x.setAttribute('aria-current','false')});
      t.setAttribute('aria-current','true');
    });
  });

  /* ---------- qty steppers ---------- */
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-qty-step]'); if(!b) return;
    var input=b.parentNode.querySelector('input');
    var v=parseInt(input.value||'1',10)+parseInt(b.getAttribute('data-qty-step'),10);
    input.value=Math.max(1,v);
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });
})();
